export const TotalDocumentsIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0001 16.5555C10.1232 16.5555 8.03114 16.5538 6.00869 16.5538C4.34848 16.5538 3.00231 15.2067 3.00391 13.5465C3.00639 10.9572 3.00639 8.65387 3.00391 6.06455C3.00231 4.40434 4.34855 3.05746 6.00876 3.05859C8.00298 3.05995 9.99722 3.05995 11.9914 3.05859C13.6517 3.05746 14.9979 4.40411 14.9975 6.06433C14.997 8.53972 15.0001 10.7424 15.0001 13.5555M12.0001 16.5555V14.3055C12.0001 13.8913 12.3359 13.5555 12.7501 13.5555H15.0001M12.0001 16.5555L15.0001 13.5555M5.25014 6.80551L6.50014 8.30551L9.00014 5.30551"
        stroke="#525866"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
